import { useState } from 'react';

export const useAttachmentState = () => {
    const [showPreview, setShowPreview] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [showAIEditModal, setShowAIEditModal] = useState(false);
    const [showCropModal, setShowCropModal] = useState(false);
    const [isAIEditing, setIsAIEditing] = useState(false);
    const [isCropping, setIsCropping] = useState(false);
    const [imageTimestamp, setImageTimestamp] = useState(Date.now());

    return {
        showPreview,
        setShowPreview,
        imageLoaded,
        setImageLoaded,
        showAIEditModal,
        setShowAIEditModal,
        showCropModal,
        setShowCropModal,
        isAIEditing,
        setIsAIEditing,
        isCropping,
        setIsCropping,
        imageTimestamp,
        setImageTimestamp
    };
};
